import * as React from "react";
import { FieldEditor } from "./FieldEditor";
import * as Forms from "../../forms";
import { Utility } from "../../utils";
import { WrapperLess } from "../generic";
import { IComponentWithValidatedForm } from "../validation";

interface OwnProps {
    formComponent: IComponentWithValidatedForm;
    namePrefix?: string;
    section: Forms.FormBuilder.FormSectionData;
}

interface OwnState {
}

export class FieldSection extends React.Component<OwnProps, OwnState> {
    public render() {
        const s = this.props.section;
        const fields = (s.fields || []).map((f, i) => <FieldEditor
            field={f}
            formComponent={this.props.formComponent}
            namePrefix={this.props.namePrefix}
            key={i}
            sectionIndex={s.index}
        />);

        const title = s.title
            ? <h2 id={"section-" + Utility.toSlug(s.title)}>{s.title}</h2>
            : null;

        const description = s.description
            ? <div dangerouslySetInnerHTML={{ __html: s.description }} />
            : null;

        return <WrapperLess>
            {title}
            {description}
            {fields}
            <hr />
        </WrapperLess>;
    }
}



// WEBPACK FOOTER //
// ./src/components/formBuilder/FieldSection.tsx